import { KeyboardDoubleArrowRight } from "@mui/icons-material"
import { Collapse, Grid, IconButton, Tooltip } from "@mui/material"
import { ReactNode } from "react"

type SidebarProps = {
  isExpanded: boolean
  onExpand: () => void
  children: ReactNode
  expandedWidth?: string
  collapsedWidth?: string
}

const Sidebar = ({
  isExpanded,
  children,
  expandedWidth = "250px",
  collapsedWidth = "50px",
  onExpand,
}: SidebarProps) => {
  return (
    <Collapse
      in={isExpanded}
      orientation="horizontal"
      sx={{
        height: "100%",
        border: "1px solid #e7e7e7",
        ".MuiCollapse-wrapper": {
          width: expandedWidth,
        },
        " .MuiCollapse-wrapperInner": {
          width: "100%",
          position: "relative",
        },
      }}
      timeout={500}
      collapsedSize={collapsedWidth}
    >
      <Grid
        container
        direction="column"
        spacing={2}
        sx={{
          height: "100%",
          width: "100%",
          position: "absolute",
          top: "16px",
          left: "16px",
          overflow: "hidden",
          ".MuiGrid-item": {
            pt: 0,
            pl: 0,
          },
        }}
      >
        {!isExpanded && (
          <Tooltip title="Expand sidebar" placement="right">
            <Grid
              container
              direction="column"
              onClick={() => onExpand()}
              sx={{
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "50px",
                cursor: "pointer",
                ":hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              <Grid item>
                <IconButton>
                  <KeyboardDoubleArrowRight />
                </IconButton>
              </Grid>
            </Grid>
          </Tooltip>
        )}

        {isExpanded && children}
      </Grid>
    </Collapse>
  )
}

export default Sidebar
